import React from 'react';
import { Dialog, DialogContent, Button } from '@mui/material';
import Lottie from 'lottie-react';
import passwordResetAnimation from '../../../assests/images/Animations/PasswordReset.json';
import {
    XTRAM_COLORS,
    XTRAM_TYPOGRAPHY,
    XTRAM_RADIUS,
    XTRAM_SPACE,
} from '../../../assests/branding/xtram/brand';
import styles from './ClientRegisterModal.module.scss';

/**
 * Similar to PasswordChanged, but for "Client Created Successfully".
 *
 * PROPS:
 *  - visible (bool) => show/hide the dialog
 *  - onClose (function) => handle close or "BackToLogin"
 *  - t (function) => translation function
 */
export default function ClientCreatedSuccessModal({ visible, onClose, t }) {
    const lang =
        (typeof document !== 'undefined' && document.documentElement.lang) || 'en';

    const brandVars = {
        '--register-blue': XTRAM_COLORS.shockingBlue,
        '--register-orange': XTRAM_COLORS.classicOrange,
        '--register-mirage': XTRAM_COLORS.mirage,
        '--register-mirage-muted': XTRAM_COLORS.mirageMuted,
        '--register-white': XTRAM_COLORS.white,
        '--register-success': XTRAM_COLORS.successGreen,
        '--register-font': XTRAM_TYPOGRAPHY.fontForLang(lang),
        '--register-text-sm': XTRAM_TYPOGRAPHY.scale.sm,
        '--register-text-md': XTRAM_TYPOGRAPHY.scale.md,
        '--register-weight-label': XTRAM_TYPOGRAPHY.weights.semiBold,
        '--register-weight-heading': XTRAM_TYPOGRAPHY.weights.bold,
        '--register-radius': XTRAM_RADIUS.lg,
        '--register-radius-md': XTRAM_RADIUS.md,
        '--register-space-sm': XTRAM_SPACE.sm,
        '--register-space-md': XTRAM_SPACE.md,
        '--register-space-lg': XTRAM_SPACE.lg,
    };

    return (
        <Dialog
            open={visible}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            classes={{ paper: styles.successDialog }}
            PaperProps={{ style: brandVars }}
        >
            <DialogContent className={styles.successContent}>
                <div className={styles.successBody}>
                    <div className={styles.successAnimation}>
                        <Lottie
                            animationData={passwordResetAnimation}
                            loop={false}
                            style={{ width: '100%', height: 'auto' }}
                        />
                    </div>
                    <div className={styles.successCopy}>
                        <p className={styles.successTitle}>
                            {t('ClientRegistered')}{' '}
                            <span className={styles.successHighlight}>
                                {t('Successfully')}
                            </span>
                        </p>
                        <p className={styles.successMessage}>
                            {t('ClientRegisteredSuccessMessage')}
                        </p>
                    </div>
                </div>
                <Button
                    variant="contained"
                    onClick={onClose}
                    className={styles.successButton}
                >
                    {t('BackToLogin')}
                </Button>
            </DialogContent>
        </Dialog>
    );
}
